// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "demo" : chunkId) + "." + {"228":"8eaa25d7","594":"825271d9","615":"51c8ce41","727":"e2d74364","762":"c8f83124","859":"94805b16"}[chunkId] + ".css";
};